export default __webpack_public_path__ + "static/media/bg.290e1bce.jpg";